// extracted by mini-css-extract-plugin
export default {"emailContainer":"MailTo_emailContainer__E0E8t","email":"MailTo_email__87IRu"};